"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var moment = require('moment');

var PrintJob = require('./PrintJob');

var ShineProducts = require('../products/ShineProducts');

var CustomSign = require('../products/components/CustomSign');

var _require = require('../products/interfaces'),
    LetterpressComponent = _require.LetterpressComponent,
    SampleComponent = _require.SampleComponent,
    Envelope = _require.Envelope,
    LargePaperComponent = _require.LargePaperComponent;

var _require2 = require('../products/constants'),
    SILK_RIBBON_SAMPLES = _require2.SILK_RIBBON_SAMPLES,
    CLASSIC_WEDDING_INVITATION_SAMPLES = _require2.CLASSIC_WEDDING_INVITATION_SAMPLES,
    LETTERPRESS_WEDDING_INVITATION_SAMPLES = _require2.LETTERPRESS_WEDDING_INVITATION_SAMPLES,
    WEDDING_PLANNER_BOXES = _require2.WEDDING_PLANNER_BOXES,
    CUSTOM_SAMPLES = _require2.CUSTOM_SAMPLES,
    LINER_SAMPLES = _require2.LINER_SAMPLES;

var _require3 = require('./helpers'),
    calculatePrintByDate = _require3.calculatePrintByDate;

function isSampleComponent(component) {
  return Object.prototype.isPrototypeOf.call(SampleComponent.prototype, component);
}

function isLetterpressComponent(component) {
  return Object.prototype.isPrototypeOf.call(LetterpressComponent.prototype, component);
}

function isLargeComponent(component) {
  if (Object.prototype.isPrototypeOf.call(CustomSign.prototype, component) && component.product_size.match(/20x30|24x36/)) {
    return true;
  }

  return Object.prototype.isPrototypeOf.call(LargePaperComponent.prototype, component);
}

function allOthers(component) {
  return !isLetterpressComponent(component) && !isLargeComponent(component) && !isSampleComponent(component);
}

function isSampleProduct(product) {
  return [SILK_RIBBON_SAMPLES, CLASSIC_WEDDING_INVITATION_SAMPLES, LETTERPRESS_WEDDING_INVITATION_SAMPLES, WEDDING_PLANNER_BOXES].includes(product.product_type);
}

function createDefaultPrintJobs(order) {
  var userOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  // which printer a component is supposed to go to could
  // come from the component, so it could be overwritten
  // like an imposition value.
  var printJobs = [];
  var activeNotes = order.notes.filter(function (_ref) {
    var active = _ref.active;
    return active;
  });
  var printJobParameters = {
    small_print_job: {
      notes: activeNotes.filter(function (_ref2) {
        var designation = _ref2.designation;
        return designation === 'small_print_job';
      }),
      products: [],
      is_reprint: order.has_reprints,
      reprint_reason: order.reprint_reason,
      printer_name: 'printingPlus',
      print_by_date: calculatePrintByDate(order, settings.printingPlus.printByDate),
      // I don't know if this is 2 day or 1 day
      printing_type: order.printing_type === 'RUSH' ? '2 DAY' : order.printing_type
    },
    custom_samples_print_job: {
      notes: activeNotes.filter(function (_ref3) {
        var designation = _ref3.designation;
        return designation === 'custom_samples_print_job';
      }),
      products: [],
      is_reprint: false,
      reprint_reason: '',
      printer_name: 'printingPlus',
      print_by_date: calculatePrintByDate(order, settings.printingPlus.printByDate),
      // I don't know if this is 2 day or 1 day
      printing_type: order.printing_type === 'RUSH' ? '2 DAY' : order.printing_type
    },
    large_print_job: {
      notes: activeNotes.filter(function (_ref4) {
        var designation = _ref4.designation;
        return designation === 'large_print_job';
      }),
      products: [],
      is_reprint: order.has_reprints,
      reprint_reason: order.reprint_reason,
      printer_name: 'printingPlus',
      print_by_date: calculatePrintByDate(order, settings.printingPlus.printByDate),
      // I don't know if this is 2 day or 1 day
      printing_type: order.printing_type === 'RUSH' ? 'STD' : order.printing_type
    },
    envelopes_print_job: {
      notes: activeNotes.filter(function (_ref5) {
        var designation = _ref5.designation;
        return designation === 'envelopes_print_job';
      }),
      products: [],
      is_reprint: order.has_reprints,
      reprint_reason: order.reprint_reason,
      printer_name: 'printingPlus',
      print_by_date: calculatePrintByDate(order, settings.printingPlus.printByDate),
      // I don't know if this is 2 day or 1 day
      printing_type: order.printing_type === 'RUSH' ? 'STD' : order.printing_type
    }
  }; // this makes copies of each product with ONLY the components that should be
  // printed by the specified print job

  var needs_letterpress_print_job = false;
  order.products.filter(function (product) {
    return !isSampleProduct(product);
  }).forEach(function (product) {
    var letterpress_components = product.components.filter(isLetterpressComponent);
    var large_components = product.components.filter(isLargeComponent);
    var all_other_components = product.components.filter(allOthers);

    if (letterpress_components.length) {
      needs_letterpress_print_job = true; // const newProduct = ShineProducts.instance().make(JSON.parse(JSON.stringify(product)));
      // printJobParameters.letterpress_print_job.products.push(newProduct);
    }

    if (letterpress_components.length && !all_other_components.length) {
      // what if a product is being sent to print with nothing but a Letterpress component?
      // I guess we just push that item onto the small print job anyway?
      var newProduct = ShineProducts.instance().make(JSON.parse(JSON.stringify(product)));
      printJobParameters.small_print_job.products.push(newProduct);
    }

    if (large_components.length) {
      var _newProduct = ShineProducts.instance().make(JSON.parse(JSON.stringify(product)));

      printJobParameters.large_print_job.products.push(_newProduct);
    }

    if (all_other_components.length && (order.designations.includes('orders') || order.designations.includes('table_numbers') || order.designations.includes('custom_samples'))) {
      var _newProduct2 = ShineProducts.instance().make(JSON.parse(JSON.stringify(product)));

      if (_newProduct2.product_type === CUSTOM_SAMPLES) {
        printJobParameters.custom_samples_print_job.products.push(_newProduct2);
      } else {
        printJobParameters.small_print_job.products.push(_newProduct2);
      }
    }

    if (order.ship_envelopes_separately) {
      var _newProduct3 = ShineProducts.instance().envelopes.make();

      var shouldAdd = false;
      product.subcomponents().forEach(function (component) {
        if (Object.prototype.isPrototypeOf.call(Envelope.prototype, component) && component.ships_separately) {
          shouldAdd = true;
          var newComponentRef;

          switch (component.name) {
            case 'A7Envelope':
              newComponentRef = _newProduct3.a7Envelopes;
              break;

            case 'A75Envelope':
              newComponentRef = _newProduct3.a75Envelopes;
              break;

            case 'ResponseCardEnvelope':
              newComponentRef = _newProduct3.responseCardEnvelopes;
              break;

            case 'ThankYouCardEnvelope':
              newComponentRef = _newProduct3.thankYouCardEnvelopes;
              break;

            case 'SaveTheDateEnvelope':
              newComponentRef = _newProduct3.saveTheDatEnvelopes;
              break;

            default:
              throw new Error("".concat(component.name, " did not match an envelope type"));
          }

          if (newComponentRef) {
            var design_name = product.design_name,
                paper_type = product.paper_type,
                ink_colors = product.ink_colors,
                letterpress_ink_colors = product.letterpress_ink_colors; // apply the corresponding product's parameters to this one.

            _newProduct3.set({
              design_name: design_name,
              paper_type: paper_type,
              ink_colors: ink_colors,
              letterpress_ink_colors: letterpress_ink_colors
            }); // add the envelope component


            newComponentRef.add(JSON.parse(JSON.stringify(component)));
          }
        }
      });

      if (shouldAdd) {
        printJobParameters.envelopes_print_job.products.push(_newProduct3);
      }
    }
  });
  Object.keys(printJobParameters).forEach(function (printJobKey) {
    if (printJobParameters[printJobKey].products.length) {
      if (printJobKey === 'small_print_job' && needs_letterpress_print_job) {
        var has_digital_components = printJobParameters[printJobKey].products.filter(function (product) {
          return product.components.filter(function (c) {
            return !isLetterpressComponent(c);
          }).length;
        }).length; // small and lp print jobs have to be the same,
        // except in the case when nothing is getting sent to printing plus at all.

        if (has_digital_components) {
          printJobs.push(new PrintJob(_objectSpread(_objectSpread({}, printJobParameters[printJobKey]), {}, {
            order_id: order.id,
            order_type: order.order_type,
            designation: printJobKey,
            date_created: moment(),
            approved_on_date: order.approved_on_date,
            name: "".concat(order.lastname, ", ").concat(order.firstname),
            designer_id: order.designer_id
          }, userOpts[printJobKey])));
        }

        printJobs.push(new PrintJob(_objectSpread({
          notes: activeNotes.filter(function (_ref6) {
            var designation = _ref6.designation;
            return designation === 'letterpress_print_job';
          }),
          designation: 'letterpress_print_job',
          products: printJobParameters[printJobKey].products,
          is_reprint: order.has_reprints,
          reprint_reason: order.reprint_reason,
          printer_name: 'pistachioPress',
          print_by_date: calculatePrintByDate(order, settings.pistachioPress.printByDate),
          printing_type: order.printing_type !== 'STD' ? 'RUSH' : 'STD',
          order_id: order.id,
          order_type: order.order_type,
          date_created: moment(),
          approved_on_date: order.approved_on_date,
          name: "".concat(order.lastname, ", ").concat(order.firstname),
          designer_id: order.designer_id
        }, userOpts.letterpress_print_job)));
      } else {
        printJobs.push(new PrintJob(_objectSpread(_objectSpread({}, printJobParameters[printJobKey]), {}, {
          order_id: order.id,
          order_type: order.order_type,
          designation: printJobKey,
          date_created: moment(),
          approved_on_date: order.approved_on_date,
          name: "".concat(order.lastname, ", ").concat(order.firstname),
          designer_id: order.designer_id
        }, userOpts[printJobKey])));
      }
    }
  }); // if there are nothing but letterpress components, we have to make an exception to the above.

  if (printJobs.length === 0 && needs_letterpress_print_job) {
    printJobs.push(new PrintJob(_objectSpread({
      notes: activeNotes.filter(function (_ref7) {
        var designation = _ref7.designation;
        return designation === 'letterpress_print_job';
      }),
      designation: 'letterpress_print_job',
      products: order.products,
      is_reprint: order.has_reprints,
      reprint_reason: order.reprint_reason,
      printer_name: 'pistachioPress',
      print_by_date: calculatePrintByDate(order, settings.pistachioPress.printByDate),
      printing_type: order.printing_type !== 'STD' ? 'RUSH' : 'STD',
      order_id: order.id,
      order_type: order.order_type,
      date_created: moment(),
      approved_on_date: order.approved_on_date,
      name: "".concat(order.lastname, ", ").concat(order.firstname),
      designer_id: order.designer_id
    }, userOpts.letterpress_print_job)));
  }

  if (printJobs.length === 1 && printJobs[0].designation === 'small_print_job' && printJobs[0].products.length === 1 && printJobs[0].products[0].product_type === LINER_SAMPLES) {
    printJobs[0].designation = 'liner_samples_print_job';
  }

  return printJobs;
}

module.exports = createDefaultPrintJobs;